
import Vue from 'vue';
import Vuex from 'vuex';
import dayjs from 'dayjs';
import axios from 'axios';
import _ from 'lodash';

import menu from './menu';

Vue.use(Vuex);

const store = new Vuex.Store({

    state: {
        ...menu,
        odds_type: {
            'odds_fr_1': {
                'value': 'odds_fr_1',
                'label': 'Esito finale 1',
                'group': 'Esito finale 1X2',
                'group_key': 'fr',
                'slug': '1'
            },
            'odds_fr_2': {
                'value': 'odds_fr_2',
                'label': 'Esito finale 2',
                'group': 'Esito finale 1X2',
                'group_key': 'fr',
                'slug': '2'
            },
            'odds_fr_x': {
                'value': 'odds_fr_x',
                'label': 'Esito finale X',
                'group': 'Esito finale 1X2',
                'group_key': 'fr',
                'slug': 'X'
            },
            'odds_dc_1x': {
                'value': 'odds_dc_1x',
                'label': 'Esito finale 1X',
                'group': 'Double Chance',
                'group_key': 'dc',
                'slug': '1X'
            },
            'odds_dc_x2': {
                'value': 'odds_dc_x2',
                'label': 'Esito finale X2',
                'group': 'Double Chance',
                'group_key': 'dc',
                'slug': 'X2'
            },
            'odds_dc_12': {
                'value': 'odds_dc_12',
                'label': 'Esito finale 12',
                'group': 'Double Chance',
                'group_key': 'dc',
                'slug': '12'
            },
            'odds_gou_over25': {
                'value': 'odds_gou_over25',
                'label': 'Over 2.5',
                'group': 'Under / Over 2.5',
                'group_key': 'gou',
                'slug': 'O2,5'
            },
            'odds_gou_under25': {
                'value': 'odds_gou_under25',
                'label': 'Under 2.5',
                'group': 'Under / Over 2.5',
                'group_key': 'gou',
                'slug': 'U2,5'
            },
            'odds_btts_yes': {
                'value': 'odds_btts_yes',
                'label': 'Goal',
                'group': 'Goal / NoGoal',
                'group_key': 'btts',
                'slug': 'G'
            },
            'odds_btts_no': {
                'value': 'odds_btts_no',
                'label': 'NoGoal',
                'group': 'Goal / NoGoal',
                'group_key': 'btts',
                'slug': 'NG'
            }
        },
        user: null,
        flash: false,
        bill: [],
        bookmarks: [],
        selectedOdds: [],
        notifications: false,
    },

    mutations: {
        setUserData (state, user) {
            state.user = user;
            localStorage.setItem('user', JSON.stringify(user));
            axios.defaults.headers.common.Authorization = `Bearer ${user.token}`
        },

        setProfilePicture (state, profilePicture) {
            if (state.user && state.user.user) {
                state.user.user.profile_picture = profilePicture;
                localStorage.setItem('user', JSON.stringify(state.user));
            }
        },

        setProfilePictureCache (state, base64Image) {
            localStorage.setItem('profile_picture_cache', base64Image);
            localStorage.setItem('profile_picture_cache_time', Date.now().toString());
        },

        clearProfilePictureCache (state) {
            localStorage.removeItem('profile_picture_cache');
            localStorage.removeItem('profile_picture_cache_time');
        },

        clearUserData () {
            const user = JSON.parse(localStorage.getItem('user'));
            if( user ){
                axios.post(
                    '/auth/logout',
                    { },
                    {
                        headers: {
                            common: {
                                'Authorization': `Bearer ${user.token}`
                            }
                        }
                    }
                );
            }

            localStorage.removeItem('user');
            window.location.href = '/';
        },

        setFlash(state, flash){
            state.flash = flash;
        },

        // Bill
        setBillData (state, bill) {
            state.bill = bill;
        },

        async addEventToBill(state, event){
            console.log('aggiungo evento', event);

            // se esiste gia lo cancello prima
            await this.commit('removeEventToBill', event.event.id);

            // aggiungo l'evento
            state.bill.push(event);
            console.log('Aggiunto');

            return;
        },

        async removeEventToBill(state, event_id){
            console.log('rimuovo evento', event_id);

            state.bill.forEach(function(item, index) {
                if(item.event.id == event_id){
                    state.bill.splice(index, 1);
                    console.log('trovato e rimosso')
                }
            });

            return;
        },

        clearBill(state){
            state.bill = [];
        },

        // Bookmarks
        setBookmarksData (state) {
            if(!this.getters.isLoggedIn) return [];

            axios.get('/bookmark/index')
            .then(({data}) => {
                state.bookmarks = data;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
        },

        async addEventToBookmarks(state, event, odd_type = null){
            console.log('aggiungo evento ai preferiti', event);
            event.event_id = event.event_id ?? event.id;
            event.odds_type = event.odds_type ?? state.selectedOdds.find((odd) => odd.event_id === event.event_id).odds_type;

            // se l'evento esiste già lo elimino prima
            await this.commit('removeEventToBookmarks', event.event_id);

            // aggiungo l'evento
            state.bookmarks.push(event);
            console.log('- Aggiunto');
        },

        async removeEventToBookmarks(state, event_id){
            console.log('rimuovo evento dai preferiti', event_id);

            state.bookmarks.forEach(function(item, index) {
                if(item.event_id == event_id){
                    state.bookmarks.splice(index, 1);
                    console.log('- Trovato e rimosso')
                }else{
                    console.warn('- Non presente');
                }
            });

            return true;
        },

        setNotificationsData (state, data) {
            state.notifications = data;
        },

        selectedOdds(state, data) {
            state.selectedOdds.push(data);
            return;
        },

        unselectOdd(state, event_id) {
            state.selectedOdds = state.selectedOdds.filter(
                (odd) => odd.event_id !== event_id
            );
            return;
        },

        unselectOdds(state) {
            state.selectedOdds = [];
        }
    },

    actions: {
        login ({ commit, dispatch }, credentials) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/login', credentials)
                .then(({ data }) => {
                    commit('setUserData', data);
                    // Carica la foto profilo dopo il login
                    axios.get('/user/me')
                        .then(({data: userData}) => {
                            if (userData.profile_picture) {
                                commit('setProfilePicture', userData.profile_picture);
                                dispatch('cacheProfilePicture', userData.profile_picture);
                            }
                        })
                        .catch(error => console.error('Errore caricamento foto profilo:', error));
                    resolve(data);
                }).catch((error) => {
                    reject(error)
                });
            });
        },

        updateProfilePicture ({ commit, dispatch }, profilePicture) {
            commit('setProfilePicture', profilePicture);
            // Invalida la cache e ricarica la nuova immagine
            commit('clearProfilePictureCache');
            dispatch('cacheProfilePicture', profilePicture);
        },

        loadProfilePicture ({ commit, dispatch, state }) {
            // Carica la foto profilo solo se non è già presente
            if (!state.user?.user?.profile_picture) {
                axios.get('/user/me')
                    .then(({data}) => {
                        if (data.profile_picture) {
                            commit('setProfilePicture', data.profile_picture);
                            dispatch('cacheProfilePicture', data.profile_picture);
                        }
                    })
                    .catch(error => console.error('Errore caricamento foto profilo:', error));
            }
        },

        cacheProfilePicture ({ commit }, imageUrl) {
            if (!imageUrl || imageUrl === '/images/default-avatar.png') return;

            // Scarica l'immagine e convertila in base64
            fetch(imageUrl)
                .then(response => response.blob())
                .then(blob => {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    });
                })
                .then(base64 => {
                    commit('setProfilePictureCache', base64);
                })
                .catch(error => {
                    console.error('Errore nel caching della foto profilo:', error);
                });
        },

        logout ({ commit }) {
            commit('clearUserData');
        },

        flashSuccess({ commit }, content){
            commit('setFlash', {
                type: 'success',
                time: dayjs().format('DD/MM HH:mm:ss'),
                content: content ? content : { message: 'Success!' }
            });
        },

        flashWarning({ commit }, content){
            commit('setFlash', {
                type: 'warning',
                time: dayjs().format('DD/MM HH:mm:ss'),
                content: content ? content : { message: 'Warning!' }
            });
        },

        flashDanger({ commit }, content){
            console.log(content);
            commit('setFlash', {
                type: 'danger',
                time: dayjs().format('DD/MM HH:mm:ss'),
                content: content ? content : { message: 'Error!' }
            });
        },

        flashOut(){
            commit('setFlash', false);
        },       

        async getNotifications({ commit }) {
            const response = await axios.get('/notification/index');
            commit('setNotificationsData', response.data);            
        },

        clearBill({ commit }){
            commit('clearBill');
        },

        selectedOdds({ commit }, data) {
            commit('selectedOdds', {
                event_id: data.event_id,
                odds_type: data.odds_type,
                odds_value: data.odds_value
            });
        }
    },

    getters : {
        isLoggedIn: state => !!state.user,
        user_id: state => state.user.user.id,
        user: state => state.user,
        usergroup: state => state.user?.user?.usergroup?.slug,
        profilePicture: state => {
            // Prima controlla se c'è una versione cachata (base64) nel localStorage
            try {
                const cachedImage = localStorage.getItem('profile_picture_cache');
                const cacheTime = localStorage.getItem('profile_picture_cache_time');
                
                // Cache valida per 24 ore
                const cacheMaxAge = 24 * 60 * 60 * 1000;
                const isCacheValid = cacheTime && (Date.now() - parseInt(cacheTime)) < cacheMaxAge;
                
                if (cachedImage && isCacheValid) {
                    return cachedImage;
                }
            } catch (e) {
                console.error('Errore nel recupero cache foto profilo:', e);
            }
            
            // Se non c'è cache valida, usa l'URL dallo stato
            if (state.user?.user?.profile_picture) {
                return state.user.user.profile_picture;
            }
            
            // Prova a recuperarla dal localStorage
            try {
                const userInfo = localStorage.getItem('user');
                if (userInfo) {
                    const userData = JSON.parse(userInfo);
                    if (userData?.user?.profile_picture) {
                        return userData.user.profile_picture;
                    }
                }
            } catch (e) {
                console.error('Errore nel recupero URL foto profilo da localStorage:', e);
            }
            
            // Fallback all'immagine default
            return '/images/default-avatar.png';
        },
        bill: state => state.bill,
        odds_type: state => state.odds_type,
        bookmarks: state => {
            var b = state.bookmarks;
            b = _.mapKeys(b, 'event_id');
            b = _.mapValues(b, 'odds_type');
            return b;
        },

        odds_label: (state) => (k) => state.odds_type[ k ] ? state.odds_type[ k ].label : k,
        odds_slug: (state) => (k) => state.odds_type[ k ] ? state.odds_type[ k ].slug : k,

        notifications: state => state.notifications,
        isOddSelected: (state) => (event_id, odds_type) => {
            return state.selectedOdds.some(
                (odd) => odd.event_id === event_id && odd.odds_type === odds_type
            );
        },
        getSelectedOdd: (state) => (event_id) => {
            return state.selectedOdds.find((odd) => odd.event_id === event_id);
        },
        getOddValue: (state) => (event_id, odds_type) => {
            const odd = state.selectedOdds.find(
                (odd) => odd.event_id === event_id && odd.odds_type === odds_type
            );
            return odd ? odd.odd_value : null;
        },
    }
});

store.watch(
    (state) => {
        return state.bill
    },
    (value) => {
        console.log('Store watch -> Bill');
        localStorage.setItem('bill', JSON.stringify(value));
    }
)

store.watch(
    (state) => {
        return state.bookmarks
    },
    (value) => {
        console.log('Store watch -> Bookmarks');

        axios.post('/bookmark/sync', {events: value})
        .then((success) => {
            console.log('Success', success);
        })
        .catch((error) => {
            console.warn('Error', error);
        });
    }
)

export default store
